import { Campaign, CampaignConfig } from './types';

export function getCampaignByProduct(
  campaigns: Campaign[],
  product: string,
): Campaign | undefined {
  if (product === 'cgm' || product === 'm1') {
    return campaigns.find(
      (campaign) => campaign.product === 'cgm' || campaign.product === 'm1',
    );
  }

  return campaigns.find((campaign) => campaign.product === product);
}

export function getCampaignConfig(
  campaign: Campaign | undefined,
): CampaignConfig | undefined {
  if (!campaign) {
    return undefined;
  }

  return {
    discountCode: campaign.discount_code,
    discount: campaign.discount_value,
    discountType: campaign.discount_type,
    active: true,
    product: campaign.product,
  };
}
